export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'An intervention level with the same name already exists in this facility'
    }
  }
}
